import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-sub-contractor',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './sub-contractor.component.html',
  styleUrls: ['./sub-contractor.component.css'],
})
export class SubContractorComponent implements OnInit {
  form: FormGroup;

  showTitleError = false;
  showFileError = false;

  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private toast: NgToastService
  ) {
    // Initialize the form group in the constructor
    this.form = this.fb.group({
      subContractorTitle: [''],
      subContractorDescription: ['', Validators.required],
      subContractorFile: [null],
    });
  }

  // File state
  uploadedFile: File | null = null;

  ngOnInit() {
    // Initialize form with form controls
    this.form = new FormGroup({
      subContractorTitle: new FormControl(''),
      subContractorDescription: new FormControl('', [Validators.required]),
      subContractorFile: new FormControl([null]),
    });
  }

  // Handle file upload
  onFileUpload(event: any) {
    this.uploadedFile = event.target.files[0];
    console.log('Uploaded File: ', this.uploadedFile);

    if (this.uploadedFile) {
      // Make insuranceTitle required when a file is uploaded
      this.form.get('subContractorTitle')?.setValidators([Validators.required]);
      this.form.get('subContractorTitle')?.updateValueAndValidity(); // Trigger validation
    } else {
      // Remove required validator if no file is uploaded
      this.form.get('subContractorTitle')?.clearValidators();
      this.form.get('subContractorTitle')?.updateValueAndValidity(); // Trigger validation
    }
  }

  // Handle form submission
  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      // Form data
      const formData = this.form.value;
      // File data
      if (this.uploadedFile) {
        console.log('File to be uploaded:', this.uploadedFile);
      }
      const dataToSubmit = new FormData();
      dataToSubmit.append('name', formData.subContractorTitle);
      dataToSubmit.append('description', formData.subContractorDescription);

      dataToSubmit.append('project_id', '1');
      dataToSubmit.append('document_title', 'compliance document');
      dataToSubmit.append('document_type', 'document');
      dataToSubmit.append('document_user_doc_no', 'AAAA - 01');
      dataToSubmit.append('attach_documents', '1');
      dataToSubmit.append('document_status', 'draft');

      if (this.uploadedFile) {
        dataToSubmit.append('insuranceFile', this.uploadedFile);
        dataToSubmit.append('insuranceTitle', formData.insuranceTitle); // Title is required if file is uploaded
      }

      console.log('Form Data:', dataToSubmit);

      this.projectsService.addProjectContractor(dataToSubmit).subscribe({
        next: (response: any) => {
          console.log('Project contract added successfully:', response);
          this.toast.success(
            'Project sub contractor added successfully',
            'SUCCESS',
            4000
          );
          this.form.reset();
        },
        error: (error: any) => {
          console.error('Login failed:', error);
          this.toast.danger(
            'Failed to add sub contractor of project',
            'DANGER',
            4000
          ); // Show error toast
        },
      });
    } else {
      // Show error if file is uploaded but title is missing
      if (this.uploadedFile && !this.form.get('subContractorTitle')?.valid) {
        console.log('Title is required when a file is uploaded');
      }
    }
  }
}
